/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSectionPanelFragment, SectionPanelFragment, FullSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel';

/**
 * Get a single SectionPanel by ID (base - scalars only)
 */
export const getBaseSectionPanelById = gql`
  ${BaseSectionPanelFragment}

  query GetBaseSectionPanelById($id: String!, $locale: String!, $preview: Boolean) {
    sectionPanel(id: $id, locale: $locale, preview: $preview) {
      ...BaseSectionPanelFragment
    }
  }
`;

/**
 * Get a single SectionPanel by ID (standard - 1 level deep)
 */
export const getSectionPanelById = gql`
  ${SectionPanelFragment}

  query GetSectionPanelById($id: String!, $locale: String!, $preview: Boolean) {
    sectionPanel(id: $id, locale: $locale, preview: $preview) {
      ...SectionPanelFragment
    }
  }
`;

/**
 * Get a single SectionPanel by ID (full - 2 levels deep)
 */
export const getFullSectionPanelById = gql`
  ${FullSectionPanelFragment}

  query GetFullSectionPanelById($id: String!, $locale: String!, $preview: Boolean) {
    sectionPanel(id: $id, locale: $locale, preview: $preview) {
      ...FullSectionPanelFragment
    }
  }
`;

/**
 * Get all SectionPanel entries with pagination (base - scalars only)
 */
export const getBaseSectionPanels = gql`
  ${BaseSectionPanelFragment}

  query GetBaseSectionPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SectionPanelOrder]
    $where: SectionPanelFilter
    $preview: Boolean
  ) {
    sectionPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSectionPanelFragment
      }
    }
  }
`;

/**
 * Get all SectionPanel entries with pagination (standard - 1 level deep)
 */
export const getSectionPanels = gql`
  ${SectionPanelFragment}

  query GetSectionPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SectionPanelOrder]
    $where: SectionPanelFilter
    $preview: Boolean
  ) {
    sectionPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SectionPanelFragment
      }
    }
  }
`;

/**
 * Get all SectionPanel entries with pagination (full - 2 levels deep)
 */
export const getFullSectionPanels = gql`
  ${FullSectionPanelFragment}

  query GetFullSectionPanels(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SectionPanelOrder]
    $where: SectionPanelFilter
    $preview: Boolean
  ) {
    sectionPanelCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSectionPanelFragment
      }
    }
  }
`;
